import request from '../../../axios';

const patchUserPromotedAdvertisement = async (guid: string) => {
  await request.patch(`/api/v2/store/user-promoted-advertisement/${guid}`);
};

export default patchUserPromotedAdvertisement;
